<template>
  <div class="container">
    <div class="tit">{{ $t('common').Activecenter }}</div>
    <div class="info">
      <img class="topimg" src="@/assets/img/activity_auth.png" />
      <div class="content ql-editor" v-html="$t('activity').authRewardTxt"></div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
    }
  },

  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  margin-bottom: -60px;
  width: 100%;
  background: var(--background_color);

  .tit {
    font-size: 36px;
    font-weight: bold;
    color: var(--text_color);
    margin: 0 auto;
    max-width: 1280px;
    padding-bottom: 40px;
    border-bottom: 1px solid var(--info_color);
  }

  .info {
    margin: 50px auto;
    max-width: 780px;

    .topimg {
      width: 50%;
    }

    .content {
      margin-top: 15px;
      font-size: 14px;
      color: var(--text_color);
      line-height: 25px;
      white-space: pre-wrap;
    }
  }
}
</style>
